import { Box, Flex, Icon, Text } from '@chakra-ui/react';
import { EventContentArg } from '@fullcalendar/react';
import React, { memo } from 'react';
import { FaCheckCircle } from 'react-icons/fa';
import { IoMdCloseCircle } from 'react-icons/io';

import { IconBan } from 'assets/icons';

interface IEventContentProps {
  arg: EventContentArg;
}

const EventContent: React.FC<IEventContentProps> = ({ arg }) => {
  const label = arg.view.type === 'dayGridMonth' ? arg.event.title : arg.event.extendedProps.category_name;

  return (
    <Box p="1" pl="2">
      <Flex alignItems="center">
        {arg.event.extendedProps?.is_withdrawn ? (
          <Icon as={IconBan} mr="1" mt="1" fontSize="sm" />
        ) : arg.event.extendedProps?.is_approve ? (
          <Icon as={FaCheckCircle} mr="1" color="success.500" fontSize="13px" />
        ) : arg.event.extendedProps?.is_reject ? (
          <Icon as={IoMdCloseCircle} mr="1" color="newRed.1000" fontSize="md" />
        ) : null}
        <Text isTruncated title={label} fontWeight="semibold" fontSize="sm">
          {label || 'N/A'}
        </Text>
      </Flex>
      {arg.view.type === 'dayGridMonth' && arg.event.extendedProps?.category_name ? (
        <Text fontSize="xs" isTruncated>
          {arg.event.extendedProps?.category_name}{' '}
        </Text>
      ) : null}
    </Box>
  );
};

export default memo(EventContent);
